import { createI18n } from 'vue-i18n'
import type { MessageSchema, SupportedLocale } from './types'
import en from './locales/en'
import es from './locales/es'
import de from './locales/de'

const getBrowserLocale = (): string => {
  // Optional: Check for ?lang=es in URL
  const urlParams = new URLSearchParams(window.location.search);
  const urlLang = urlParams.get('lang');
  if (urlLang && ['en', 'es', 'de'].includes(urlLang)) {
    return urlLang;
  }
  
  const browserLang = navigator.language.split('-')[0];
  console.log(`Detected browser language: ${browserLang}`);
  const supportedLocales = ['en', 'es', 'de'];
  return supportedLocales.includes(browserLang) ? browserLang : 'en';
};

const i18n = createI18n<[MessageSchema], SupportedLocale>({
  legacy: false, // Use Composition API mode
  locale: getBrowserLocale() as SupportedLocale,
  fallbackLocale: 'en',
  messages: {
    en,
    es,
    de
  }
})

export default i18n